import React from "react";
import { Form } from "react-bootstrap";
import { ModalPayment } from "../../ui/templates/modal";
import Driver from "./driver";
import Crew from "./crew";
import { Box } from "@material-ui/core";
import { fontStyleBlack } from "../../ui/constants";

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);
    const { team } = this.props;
    this.state = {
      selectedCaptainId: team?.team_info?.creator_id,
    };
  }

  renderNumberOption = (items, email) => {
    return items.filter((item, k) => {
      return (
        item.email !== null &&
        item.email !== email &&
        item.payment_info === null
      );
    });
  };
  handleSelectCaptain = (captainId) => {
    const { handleCreateTeam } = this.props;
    this.setState({ selectedCaptainId: captainId }, () => {
      handleCreateTeam({}, { creator_id: this.state.selectedCaptainId });
    });
  };
  filterDriverLicenses = (driverLicenses, eventLicenses) => {
    return driverLicenses.map(driver => ({
        ...driver,
        matchedLicense: JSON.parse(driver.license || '[]').filter(driverLicense =>
            eventLicenses?.some(eventLicense =>
                eventLicense.licenseType === driverLicense.licenseType
            )
        )
    }));
  };

  render() {
    const {
      team,
      handleDeleteUserFromSlot,
      cardNonceResponseReceived,
      handleSaveLicenseForSlot,
      selectedPrice,
      handleCancelClick,
      handlePayClick,
      handleAssignPayment,
      handleGetInvoice,
      findByRole,
      handleEventDetailsPush,
      handleCreateTeam,
      handleDriverLicenseUpdate,
    } = this.props;
    const { selectedCaptainId } = this.state;
    const filteredDrivers = this.filterDriverLicenses(team?.team_slots?.drivers, JSON.parse(team?.team_info?.eventLicense || '[]'));
    const filterExtraDrivers = this.filterDriverLicenses(team?.team_slots?.extra_drivers, JSON.parse(team?.team_info?.eventLicense || '[]'));
    return (
      <Form
        className="paymentSection"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {selectedPrice > 0 && (
          <ModalPayment
            price={selectedPrice}
            team={team}
            cardNonceResponseReceived={cardNonceResponseReceived}
            onCancel={handleCancelClick}
          />
        )}
        <Form.Group>
          <Box mb={1.5} className="fontStyle teamHeading">
            Payment
          </Box>
        </Form.Group>
        <Form.Group>
          <Box className="fontStyle">Drivers</Box>
        </Form.Group>
        {filteredDrivers?.map((i, k) => {
          return (
            <Box className="driveApp">
              <Driver
                key={k}
                i={i}
                k={k}
                handleCreateTeam={handleCreateTeam}
                findByRole={findByRole}
                team={team}
                handleSelectCaptain={this.handleSelectCaptain}
                selectedCaptainId={selectedCaptainId}
                handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                handleDeleteUserFromSlot={handleDeleteUserFromSlot}
                handlePayClick={handlePayClick}
                handleGetInvoice={handleGetInvoice}
                handleAssignPayment={handleAssignPayment}
                renderNumberOption={this.renderNumberOption}
                handleEventDetailsPush={handleEventDetailsPush}
                handleDriverLicenseUpdate={handleDriverLicenseUpdate}
              />
            </Box>
          );
        })}
        {team.team_slots.extra_drivers.length > 0 ? (
          <div>
            <Form.Group>
              <Box className="fontStyle">Extra Drivers</Box>
            </Form.Group>
            {filterExtraDrivers?.map((i, k) => {
              return (
                <Box className="driveApp">
                  <Driver
                    key={k}
                    i={i}
                    k={k}
                    findByRole={findByRole}
                    team={team}
                    handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                    handleDeleteUserFromSlot={handleDeleteUserFromSlot}
                    handlePayClick={handlePayClick}
                    handleGetInvoice={handleGetInvoice}
                    handleAssignPayment={handleAssignPayment}
                    renderNumberOption={this.renderNumberOption}
                    handleDriverLicenseUpdate={handleDriverLicenseUpdate}
                  />
                </Box>
              );
            })}
          </div>
        ) : null}
        <Form.Group>
          <Box className="fontStyle">Crews</Box>
        </Form.Group>
        {team.team_slots.crews.map((i, k) => {
          return (
            <Box className="crewApp">
              <Crew
                key={k}
                i={i}
                k={k}
                team={team}
                findByRole={findByRole}
                handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                handleDeleteUserFromSlot={handleDeleteUserFromSlot}
                handlePayClick={handlePayClick}
                handleGetInvoice={handleGetInvoice}
                handleAssignPayment={handleAssignPayment}
                renderNumberOption={this.renderNumberOption}
              />
            </Box>
          );
        })}
        {team.team_slots.extra_crews.length > 0 ? (
          <div>
            <Form.Group>
              <Box style={fontStyleBlack}>Extra Crews</Box>{" "}
            </Form.Group>

            {team.team_slots.extra_crews.map((i, k) => {
              return (
                <Box className="crewApp">
                  <Crew
                    key={k}
                    i={i}
                    k={k}
                    team={team}
                    findByRole={findByRole}
                    handleSaveLicenseForSlot={handleSaveLicenseForSlot}
                    handleDeleteUserFromSlot={handleDeleteUserFromSlot}
                    handlePayClick={handlePayClick}
                    handleGetInvoice={handleGetInvoice}
                    handleAssignPayment={handleAssignPayment}
                    renderNumberOption={this.renderNumberOption}
                  />
                </Box>
              );
            })}
          </div>
        ) : null}
      </Form>
    );
  }
}

export default PaymentForm;
